import {
  Box,
  type BoxProps,
  Flex,
  Checkbox,
  Text,
} from '@mantine/core'
import { clsx } from 'clsx'
import { useState, useEffect } from 'react'

import { Trans, useTranslation } from '@flecto/translations'
import { type CoreInquiry } from '@flecto/types'
import { useLocaleInfo } from '@flecto/utils'

import styles from './styles.module.css'

export type SectionInquiryNotificationProps = Omit<
  BoxProps,
  'children'
> & {
  value?: boolean
  inquiry?: CoreInquiry
  onChange?: (checked: boolean) => void
}

export function SectionInquiryNotification({
  value,
  inquiry,
  onChange,
  ...props
}: SectionInquiryNotificationProps) {
  const [checked, setChecked] = useState(false)

  const { t } = useTranslation('saas', { keyPrefix: 'booking_customer' })

  const { name: localeName } = useLocaleInfo({
    locale: inquiry?.locale ?? 'pt',
  })

  const customerName = inquiry?.customer.full_name ?? inquiry?.full_name

  const handleChange = (value: boolean) => {
    setChecked(value)
    onChange?.(value)
  }

  useEffect(() => {
    if (typeof value === 'boolean') {
      setChecked(value)
    }
  }, [value])

  return (
    <Box
      {...props}
      className={clsx(styles.section, props.className, {
        [styles.sectionChecked]: checked,
      })}
      onClick={() => handleChange(!checked)}
    >
      <Flex gap='sm' align='flex-start'>
        <Checkbox
          checked={checked}
          onChange={(e) => handleChange(e.currentTarget.checked)}
        />

        <Box mt={-2} w={'100%'}>
          <Text fw={500}>
            {t('card_notification_email_title')}
          </Text>
          <Text size='sm' c='dimmed'>
            <Trans
              ns='saas'
              i18nKey='booking_customer.card_notification_email_description'
              values={{
                customer: customerName,
                language: localeName,
              }}
              components={[
                <Text fw={500} key={0} display={'inline-flex'} />,
                <Text fw={500} key={1} display={'inline-flex'} />,
              ]}
            />
          </Text>
        </Box>
      </Flex>
    </Box>
  )
}
